<template>
    <div class="jr-component">
      <el-checkbox v-model="checked" v-bind="$attrs" :id="id" :disabled="!BadgeType">
        <span><slot></slot></span>
      </el-checkbox>          
      <i @click="rightClick" v-if="badge & BadgeType" class="el-icon-success jr-right-ico" style="color: green;"/>
      <i @click="rightClick" v-if="badge & !BadgeType" class="el-icon-error jr-right-ico" style="color: red;"/>
    </div>
</template>
<script>
import store from '@/store'
export default {
  name: 'JrCheckbox',    
  computed: {
    checked: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  props: {
    value: {},
    id: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    badge: {
      type: Boolean,
      default: false
    },
    BadgeType:{
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  methods: {
    rightClick(){
      this.$emit('badge-click', this.id, !this.BadgeType)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/componentsjr/JrCheckbox.vue